import './index.scss';

const trackPaywallViewed = (paywallType, event = 'paywall viewed') => {
  UserTracker.emit('event', {
    eventName: event,
    data: {
      'paywall type': paywallType,
      'request path': window.location.pathname,
      'source project': 'odin'
    }
  });
};

$(document).ready(() => {
  const baseCourseBtn = $('#js-paywall-early-modal').find('.base-course-cta');

  // opened
  $('#js-paywall-early-modal').on('shown.bs.modal', function () {
    trackPaywallViewed('curso base');
  });

  // closed
  $('#js-paywall-early-modal').on('hidden.bs.modal', function () {
    trackPaywallViewed('escolher plano');
  });

  if (baseCourseBtn.length) {
    baseCourseBtn.on('click', () => {
      trackPaywallViewed('curso base', 'paywall button clicked');
    });
  }
});
